// tslint:disable: max-line-length
import { CreateDataByIndexedDB, GetAllDataByIndexedDB } from '../../indexed/index';
import { userHotelDetails } from '../../helpers/handleBrandAndHotelData';
import axiosInstance from '../../helpers/interceptor';

export const standard = async (categoryId, fromDate, hotelId, isSelf, assessmentId, standard, performanceClassification) => {
    const { selectedHotel } = userHotelDetails();
    if (standard !== 'LQA') {
        standard = 'custom' + standard ;
    }
    let view = `view=category`;

    if (performanceClassification && performanceClassification !== 'all') {
        view = `view=performance&performanceClassification=${performanceClassification}`;
    }
    let dataD: any = []; 
    const OfflineData = await GetAllDataByIndexedDB(`${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/standards?&standard=${standard}&${view}${isSelf ? '&self=1&assessmentId=' + assessmentId : '&toDate=' + fromDate}&language=en&visit=1&categoryId=${categoryId}&isDisplayOnly=0`, selectedHotel);
    if (OfflineData) {
        dataD = OfflineData;
    } else {
        const { data } = await axiosInstance.get(`${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/standards?&standard=${standard}&${view}${isSelf ? '&self=1&assessmentId=' + assessmentId : '&toDate=' + fromDate}&language=en&visit=1&categoryId=${categoryId}&isDisplayOnly=0`);
        dataD = data;
        CreateDataByIndexedDB(`${Env.API_URL}/customer/hotel-assessment-summary/${selectedHotel}/standards?&standard=${standard}&${view}${isSelf ? '&self=1&assessmentId=' + assessmentId : '&toDate=' + fromDate}&language=en&visit=1&categoryId=${categoryId}&isDisplayOnly=0`, data, selectedHotel);
        
    }
    return dataD;
};
